import { render, staticRenderFns } from "./SavingsAccountRateEditorModal.vue?vue&type=template&id=2542bf5f"
import script from "./SavingsAccountRateEditorModal.vue?vue&type=script&lang=js"
export * from "./SavingsAccountRateEditorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports